import { graphql } from "@/lib/gql/__generated__";

export const SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query = graphql(`
	query SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query($hotelID: ID!) {
		siteControllerSettingAirHostReservationSyncJob(hotelID: $hotelID) {
			hotelID
			jobID
			status
			syncTargetStartDate
			syncTargetEndDate
			totalReservations
			syncedReservations
			skippedReservations {
				reservationID
			}
			failedReservations {
				reservationID
				error
				attemptCount
			}
			createdAt
			updatedAt
		}
	}
`);
